/** Returns up to two uppercase initials from a display name.
 * If the name is null, return "-"
 * e.g. John Doe -> JD
 *
 * @param name The name to initialize
 * @returns string - The initials
 */
export function getInitials(name: string | null): string {
  if (!name) return "-";
  const parts = name.trim().split(/\s+/);
  return parts
    .slice(0, 2)
    .map((p) => p[0].toUpperCase())
    .join("");
}
